module.exports = __webpack_public_path__ + "img/faming.cab39571.png";